
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/trending",
      function () {
        return require("private-next-pages/d/trending.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/trending"])
      });
    }
  